import controller from './sidebar.controller';
import template from './sidebar.template.html';
import './sidebar.scss';

export default {
  controller,
  template,
  transclude: {
    header: '?sidebarHeader',
  },
};




// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.js